import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { IPBoardHelper } from 'src/app/helpers/ip-board-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import UserHelper from 'src/app/helpers/user-helper';
import Employee from 'src/app/model/product/employee';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import IPBoardPlacement from 'src/app/model/product/ip-board/ip-board-placement';
import Product from 'src/app/model/product/product';
import { BaseProject } from 'src/app/model/project/base-project';
import { Project } from 'src/app/model/project/project';
import {
  GetPrintworkAndAtelierInfoForSubProjectControllerRequestService,
  PrintworkAndAtelierInfo,
} from 'src/app/services/api/immo/get-printwork-and-atelier-info/get-printwork-and-atelier-info-for-subproject-controller-request.service';
import { ResetAtelierProgressControllerRequestService } from 'src/app/services/api/immo/reset-atelier-progress/reset-atelier-progress-controller-request.service';
import { ResetPrintworkProgressControllerRequestService } from 'src/app/services/api/immo/reset-printwork-progress/reset-printwork-progress-controller-request.service';
import { AuthService } from 'src/app/services/auth.service';
import { EmployeeChoicesService } from 'src/app/services/employee-choices.service';
import { ModalService } from 'src/app/services/modal.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { StockForSignControllerRequestService } from '../../client-product-summary/client-ip-board-summary/stock-for-sign-controller-request.service';
import { SetProjectNeedsPrintworkControllerRequestService } from './set-project-needs-printwork-controller-request.service';

export class PrintWorkChecked {
  ipBoardChecked: boolean;
  titleChecked: boolean;
  phoneNumberChecked: boolean;
  textChecked: boolean;
  extraBoardChecked: boolean;
  stickerChecked: boolean;
  arrowsChecked: boolean;
  secondBoardChecked: boolean;
  otherOrderChecked: boolean;
  atelierChecked: boolean;
}

@Component({
  selector: 'ip-board-printwork-dialog',
  templateUrl: './ip-board-printwork-dialog.component.html',
  styleUrls: ['./ip-board-printwork-dialog.component.scss'],
})
export class IPBoardPrintworkDialogComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  project: Project;
  @Input()
  baseProject: BaseProject;
  @Output()
  close = new EventEmitter<boolean>();

  printworkHandlerChoices: Employee[] = [];

  selectedPrintHandler: Employee;
  selectedDeadline: Date;
  needsPrintworkDescription: string;
  needsAtelierDescription: string;

  submitting: boolean = false;

  productDescription: string = '';
  needPrintworkChecked: boolean;
  printWorkChecked: PrintWorkChecked;

  showStickerCheckbox: boolean = false;

  printworkAndAtelierInfo: PrintworkAndAtelierInfo;

  resettingPrintwork: boolean = false;
  resettingAtelier: boolean = false;

  constructor(
    private employeeChoicesService: EmployeeChoicesService,
    private setProjectNeedsPrintworkControllerRequestService: SetProjectNeedsPrintworkControllerRequestService,
    private stockForSignControllerRequestService: StockForSignControllerRequestService,
    private getPrintworkAndAtelierInfoForSubProjectControllerRequestService: GetPrintworkAndAtelierInfoForSubProjectControllerRequestService,
    private resetPrintworkProgressControllerRequestService: ResetPrintworkProgressControllerRequestService,
    private resetAtelierProgressControllerRequestService: ResetAtelierProgressControllerRequestService,
    private modalService: ModalService,
    private authService: AuthService
  ) {
    super();
  }

  ngOnInit(): void {
    if (!CollectionHelper.isPopulated(this.project.products)) {
      throw new Error('Project heeft geen producten');
    }

    this.initializeFromProduct();
    this.getPrintworkAndAtelierInfo();

    this.addSubscription(
      this.employeeChoicesService.getPrintworkHandlerChoicesSubscribable(),
      (printworkHandlers: Employee[]) => {
        this.printworkHandlerChoices = printworkHandlers;
      }
    );
  }

  private initializeFromProduct(): void {
    const firstProduct = this.project.products[0];
    this.needPrintworkChecked = firstProduct.needPrintwork;
    this.needsPrintworkDescription = firstProduct.printworkExtraInfo;
    this.needsAtelierDescription = firstProduct.atelierExtraInfo;

    this.initProductDescription(firstProduct);
    if (firstProduct.needPrintwork) {
      this.printWorkChecked = {
        ipBoardChecked: firstProduct.ipBoardCheckedPrintWork,
        titleChecked: firstProduct.titleCheckedPrintWork,
        phoneNumberChecked: firstProduct.phoneNumberCheckedPrintWork,
        textChecked: firstProduct.textPrintworkChecked,
        extraBoardChecked: firstProduct.extraBoardCheckedPrintWork,
        stickerChecked: firstProduct.stickerCheckedPrintWork,
        arrowsChecked: firstProduct.arrowCheckedPrintWork,
        secondBoardChecked: firstProduct.secondBoardCheckedPrintWork,
        otherOrderChecked: firstProduct.otherOrderCheckedPrintWork,
        atelierChecked: firstProduct.atelierCheckedPrintWork,
      };
    } else {
      this.initPrintWorkChecked(firstProduct);
    }

    if (
      ProductHelper.isIPBoard(firstProduct) &&
      (firstProduct.boardPart.sticker != null ||
        firstProduct.boardPart.otherSticker != null) &&
      firstProduct.boardPart.sign != null &&
      firstProduct.boardPart.sign['stickers'] != null &&
      firstProduct.boardPart.sign['stickers'].length > 0
    ) {
      if (firstProduct.boardPart.sticker != null) {
        const filtered = firstProduct.boardPart.sign['stickers'].find(
          (s) => s.id === firstProduct.boardPart.sticker.id
        );
        if (filtered != null) {
          this.showStickerCheckbox = !filtered.inStock;
        }
      } else {
        this.showStickerCheckbox = true;
      }
    }
  }

  private async getPrintworkAndAtelierInfo(): Promise<void> {
    if (this.baseProject != null && this.baseProject.id != null) {
      this.printworkAndAtelierInfo =
        await this.getPrintworkAndAtelierInfoForSubProjectControllerRequestService.getPrintworkAndAtelierInfoForSubProject(
          this.baseProject.id
        );
    }
  }

  needsPrintworkDescriptionChanged(value: string): void {
    this.needsPrintworkDescription = value;
  }

  needsAtelierDescriptionChanged(value: string): void {
    this.needsAtelierDescription = value;
  }

  closeDialog(): void {
    this.close.emit(false);
  }

  async confirmNeedsPrintwork(): Promise<void> {
    this.submitting = true;
    try {
      await this.setProjectNeedsPrintworkControllerRequestService.setProjectNeedsPrintwork(
        this.project.id,
        this.needPrintworkChecked,
        this.needsPrintworkDescription,
        this.needsAtelierDescription,
        this.printWorkChecked
      );
      this.project.products.forEach((p) => {
        p.needPrintwork = this.needPrintworkChecked;
        p.atelierCheckedPrintWork = this.printWorkChecked.atelierChecked;

        if (this.needsAtelierDescription) {
          p.atelierExtraInfo = this.needsAtelierDescription;
        } else {
          p.atelierExtraInfo = null;
        }

        if (this.needPrintworkChecked) {
          p.printworkExtraInfo = this.needsPrintworkDescription;
          p.printWorkReady = false;
          p.ipBoardCheckedPrintWork = this.printWorkChecked.ipBoardChecked;
          p.titleCheckedPrintWork = this.printWorkChecked.titleChecked;
          p.phoneNumberCheckedPrintWork =
            this.printWorkChecked.phoneNumberChecked;
          p.textPrintworkChecked = this.printWorkChecked.textChecked;
          p.extraBoardCheckedPrintWork =
            this.printWorkChecked.extraBoardChecked;
          p.stickerCheckedPrintWork = this.printWorkChecked.stickerChecked;
          p.arrowCheckedPrintWork = this.printWorkChecked.arrowsChecked;
          p.secondBoardCheckedPrintWork =
            this.printWorkChecked.secondBoardChecked;
          p.otherOrderCheckedPrintWork =
            this.printWorkChecked.otherOrderChecked;
        } else {
          p.printworkExtraInfo = null;
          p.ipBoardCheckedPrintWork = false;
          p.titleCheckedPrintWork = false;
          p.phoneNumberCheckedPrintWork = false;
          p.textPrintworkChecked = false;
          p.extraBoardCheckedPrintWork = false;
          p.stickerCheckedPrintWork = false;
          p.arrowCheckedPrintWork = false;
          p.secondBoardCheckedPrintWork = false;
          p.otherOrderCheckedPrintWork = false;
        }
      });
      this.baseProject.currentPrintDate = this.selectedDeadline;
      this.close.emit(true);
    } finally {
      this.submitting = false;
    }
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }

  initProductDescription(product: Product) {
    if (ProductHelper.isIPBoard(product)) {
      const boardPart = (product as IPBoard).boardPart;
      const signType =
        boardPart.sign != null
          ? boardPart.sign.type.label === 'Kleefbord'
            ? 'Kleefbord'
            : 'IP bord'
          : 'Custom bord';

      let title = '';
      let phoneNumber = '';
      let size = '';
      if (boardPart.titleAdjustment != null) {
        title = boardPart.titleAdjustment.title;
      } else if (boardPart.sign != null) {
        title = boardPart.sign.title;
      } else if (boardPart.otherTitle != null) {
        title = boardPart.otherTitle;
      }
      if (boardPart.phoneNumberAdjustment != null) {
        phoneNumber = boardPart.phoneNumberAdjustment.phoneNumber;
      } else if (boardPart.sign != null) {
        phoneNumber = boardPart.sign.phoneNumber;
      } else if (boardPart.otherPhoneNumber != null) {
        phoneNumber = boardPart.otherPhoneNumber;
      }
      if (boardPart.sign != null) {
        size =
          boardPart.sign.signMeasurements == null
            ? null
            : `${boardPart.sign.signMeasurements.height}x${boardPart.sign.signMeasurements.width}`;
      } else {
        size = `${boardPart.otherHeight}x${boardPart.otherWidth}`;
      }
      this.productDescription = `${signType} ${size} - ${title} - ${phoneNumber}`;
    }
  }

  async initPrintWorkChecked(product: Product) {
    this.printWorkChecked = new PrintWorkChecked();
    if (ProductHelper.isIPBoard(product)) {
      const ipBoard = product as IPBoard;
      const boardPart = ipBoard.boardPart;
      const productPlacement = product.productPlacement as IPBoardPlacement;
      const projectPlacement = this.baseProject.projectPlacement;
      const signId = boardPart.sign != null ? boardPart.sign.id : null;
      const signType =
        boardPart.sign != null ? boardPart.sign.type.label : null;
      const standardSignWithoutStock =
        boardPart.sign != null && boardPart.sign.withoutStock;

      let secondBoardChecked: boolean = false;
      let textChecked: boolean = false;
      let stock = null;

      if (signId != null) {
        await this.stockForSignControllerRequestService
          .totalStockForSign(signId)
          .then((s) => {
            stock = s;
          });
      }

      const titleChecked = IPBoardHelper.needsPrintworkForConfig(
        boardPart,
        'titleAdjustment',
        'otherTitle'
      );
      const otherTitleChecked = IPBoardHelper.needsPrintworkForConfig(
        boardPart,
        'otherTitleAdjustment',
        'otherSideOtherTitle'
      );
      const phoneNumberChecked = IPBoardHelper.needsPrintworkForConfig(
        boardPart,
        'phoneNumberAdjustment',
        'otherPhoneNumber'
      );
      const otherPhoneNumberChecked = IPBoardHelper.needsPrintworkForConfig(
        boardPart,
        'otherPhoneNumberAdjustment',
        'otherSideOtherPhoneNumber'
      );
      const stickerChecked = IPBoardHelper.needsPrintworkForConfig(
        boardPart,
        'sticker',
        'otherSticker'
      );

      const extraBoardChecked = ipBoard.extraBoard != null;
      const arrowsChecked = IPBoardHelper.hasArrows(productPlacement);

      if (projectPlacement.secondBoard != null) {
        secondBoardChecked =
          !projectPlacement.secondBoard.secondBoardCopy ||
          (projectPlacement.secondBoard.secondBoardCopy &&
            (stock == null || stock == 0 || standardSignWithoutStock));
        textChecked =
          projectPlacement.secondBoard.secondBoardCopy &&
          (!StringHelper.isEmptyOrWhiteSpace(boardPart.customText) ||
            !StringHelper.isEmptyOrWhiteSpace(boardPart.otherCustomText));
      }

      if (signType === 'Kleefbord' || signId == null) {
        this.printWorkChecked = {
          ipBoardChecked:
            stock == null || stock == 0 || standardSignWithoutStock,
          titleChecked:
            titleChecked ||
            otherTitleChecked ||
            (secondBoardChecked && textChecked),
          phoneNumberChecked:
            phoneNumberChecked ||
            otherPhoneNumberChecked ||
            (secondBoardChecked && textChecked),
          textChecked: false,
          extraBoardChecked: extraBoardChecked,
          stickerChecked: stickerChecked,
          arrowsChecked: arrowsChecked,
          secondBoardChecked: secondBoardChecked,
          otherOrderChecked: projectPlacement.otherOrderPlacementInfo != null,
          atelierChecked:
            product.atelierCheckedPrintWork == null
              ? true
              : product.atelierCheckedPrintWork,
        };
      } else {
        this.printWorkChecked = {
          ipBoardChecked: standardSignWithoutStock,
          titleChecked: titleChecked || otherTitleChecked,
          phoneNumberChecked: phoneNumberChecked || otherPhoneNumberChecked,
          textChecked:
            IPBoardHelper.needsPrintworkForText(boardPart) &&
            (textChecked ||
              !StringHelper.isEmptyOrWhiteSpace(boardPart.customText) ||
              !StringHelper.isEmptyOrWhiteSpace(boardPart.otherCustomText)),
          extraBoardChecked: extraBoardChecked,
          stickerChecked: stickerChecked,
          arrowsChecked: arrowsChecked,
          secondBoardChecked: secondBoardChecked,
          otherOrderChecked: projectPlacement.otherOrderPlacementInfo != null,
          atelierChecked:
            product.atelierCheckedPrintWork == null
              ? true
              : product.atelierCheckedPrintWork,
        };
      }
    }
  }

  resetPrintwork(): void {
    this.modalService.confirmDialog(
      'Printwerk resetten',
      'Bent u zeker dat u printwerk wilt resetten voor deze opdracht?',
      (b: boolean) => {
        if (b) {
          this.doResetPrintwork();
        }
      }
    );
  }

  private doResetPrintwork(): void {
    this.resettingPrintwork = true;
    this.resetPrintworkProgressControllerRequestService
      .resetPrintworkProgress(this.baseProject.id)
      .then(() => {
        if (this.printworkAndAtelierInfo != null) {
          this.printworkAndAtelierInfo.printWorkFinished = false;
        }
      })
      .finally(() => (this.resettingPrintwork = false));
  }

  resetAtelier(): void {
    this.modalService.confirmDialog(
      'Atelier resetten',
      'Bent u zeker dat u atelier wilt resetten voor deze opdracht?',
      (b: boolean) => {
        if (b) {
          this.doResetAtelier();
        }
      }
    );
  }

  private doResetAtelier(): void {
    this.resettingAtelier = true;
    this.resetAtelierProgressControllerRequestService
      .resetAtelierProgress(this.baseProject.id)
      .then(() => {
        if (this.printworkAndAtelierInfo != null) {
          this.printworkAndAtelierInfo.atelierFinished = false;
        }
      })
      .finally(() => (this.resettingAtelier = false));
  }

  impersonateAtelierEmployee(): void {
    const atelierEmployeeName = UserHelper.getDisplayName(
      this.printworkAndAtelierInfo.atelierEmployeeUser
    );
    this.modalService.confirmDialog(
      `${atelierEmployeeName} nabootsen`,
      `Bent u zeker dat u ${atelierEmployeeName} wilt nabootsen?`,
      (b: boolean) => {
        if (b) {
          this.doImpersonateAtelierEmployee();
        }
      }
    );
  }

  doImpersonateAtelierEmployee(): void {
    this.closeDialog();
    this.authService.impersonateUser(
      this.printworkAndAtelierInfo.atelierEmployeeUser
    );
  }
}
